module.exports = __webpack_public_path__ + "img/11087937_L.9886b9c6.png";